<template>
    <div style="min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;">
            <h2 class="h2">الصفحة غير موجودة</h2>
    </div>
</template>



<style  scoped>

</style>